// eslint-disable-next-line no-use-before-define
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import OrigoAppShell from "@oriola-origo/origo-app-shell";

const useStyles = makeStyles(theme => ({
  contentContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    marginLeft: "7.3%",
    marginRight: "7.3%",
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  navHelper: {
    position: "absolute",
    right: 0,
    display: "flex",
    flexDirection: "column",
    paddingRight: theme.spacing(1),
  },
  profitCenterHelper: {
    position: "absolute",
    left: 0,
    display: "flex",
    flexDirection: "column",
    paddingRight: theme.spacing(1),
  },
  title: {
    ...theme.typography.body1,
    fontWeight: "bold",
  },
}));

const ensureNoTrailingSlash = path =>
  path.endsWith("/") ? path.slice(0, -1) : path;

function Layout({ children }) {
  const classes = useStyles();
  const { tokenData } = useSelector(state => state.user);
  return (
    <OrigoAppShell
      origoUrl={ensureNoTrailingSlash(process.env.REACT_APP_ORIGO_URL)}
      origoAccessToken={tokenData.accessToken}
      queryParameters={window.location.search}
      activeApplicationId={process.env.REACT_APP_ORIGO_APP_ID}
    >
      <div className={classes.contentContainer}>{children}</div>
    </OrigoAppShell>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

Layout.defaultProps = {};

export default Layout;
